import * as yup from 'yup';
import Schema from '@/schema/Schema';
import Constant from '@/common/constant/Constant';
import { tr } from '@/common/utils/tr';

const CreateFormSchema = () =>
    Schema.object().shape({
        name: yup
            .string()
            // Message functions: translated at validation time, not frozen when the schema is built
            .required(() => tr('フォーマット名をご記入ください。'))
            .max(Constant.MAX_LENGTH.FORM_NAME, () => tr(`${Constant.MAX_LENGTH.FORM_NAME}文字の以下で入力してください。`))
            .trim(),
    });

export default CreateFormSchema;
